
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/image-list-item",
      function () {
        return require("private-next-pages/material-ui/api/image-list-item.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/image-list-item"])
      });
    }
  